import StringMask from 'string-mask'
import moment from 'moment'
import Vue from "vue"

const formatters = {
    absolute(value) {
        return value && typeof value === 'number' ? Math.abs(value) : value;
    },
    optional(value) {
        if (value === null) return null;
        if (value === "n/a") return null;
        if (value === "$0") return null;
        return value;
    },
    money(value, digits = 2) {
        if (value === null || value === undefined) return "n/a";
        let isNumber = _.isNumber(value);
        if (!isNumber) {
          value = Number.parseFloat(value);
          if (!_.isNumber(value)) return "Invalid amount";
        }
        if (value >= 0) return `$${value.toLocaleString('en-US', {minimumFractionDigits: digits})}`;
        if (value < 0) return `($${Math.abs(value).toLocaleString('en-US', {minimumFractionDigits: digits})})`;
    },
    moneySigned(value, digits = 2) {
        if (value === null || value === undefined) return "n/a";
        if (!_.isNumber(value)) return "Invalid amount";
        let numStr = '$' + Math.abs(value).toLocaleString('en-US', {minimumFractionDigits: digits});
        if (value >= 0) return numStr;
        if (value < 0) return '-' + numStr;
    },
    date(value, format = 'MM/DD/YYYY') {
        if (!value) return "none";
        return moment(value).format(format);
    },
    dateTime(value, format = 'MM/DD/YYYY hh:mm a')
    {
        return value ? moment(value).format(format) : null;
    },
    phone(value) {
        if (!value) return value;
        return formatPhone(value);
    },
    phoneAndExt(phone, ext) {
        if (!phone) return phone;
        return `${formatPhone(phone)} ${ext ? 'x' + ext : ''}`;
    },
    ssn(value) {
        let formatter = new StringMask('000-00-0000');
        return formatter.apply(value);
    },
    lastFour(value) {
        if (!value) return value;
        if (value.length <= 4) return value;

        var stars = "";
        for(let i = 0; i < value.length - 4; i++)
        {
            stars += "*";
        }
        return stars + value.substring(value.length-4);
    },
    boolean(value) {
      return value === true ? "Yes" : "No";
    },
    truncate(value, atLength = 10) {
      return value.length > atLength ?  value.slice(0, atLength) + '...' : value;
    }
}

function formatPhone(value) {
  if (!value) return value;
  value = value.toString();
  var numericPhone = _.filter(value.split(''), c => Number.isInteger(parseInt(c))).join('');
  let formatter = new StringMask('(000) 000-0000');
  return formatter.apply(numericPhone);
}

Vue.prototype.$formatters = formatters;

export { formatters };



// WEBPACK FOOTER //
// ./src/framework/utils/formatters.js